import _ from 'lodash';
import { TABLE_STORE } from 'store/shared/mixins';
import { mixVuexStoreOptions } from 'store/helpers.js';
import { apis } from 'api/client';

export default mixVuexStoreOptions({}, TABLE_STORE, {
    namespaced: true,
    state: {
        default_sort: ['name'],
        pagination: {
            page: 1,
            per_page: -1,
        },
    },
    actions: {
        async get({ state, commit }, params = {}) {
            let paramsMerged = _.merge({}, params, state.filters, state.pagination, { sort: state.sort });
            let response;
            let shoppingListLines;

            response = await apis.ShoppingListLines.listShoppingListLines(paramsMerged);
            shoppingListLines = response.body.data;
            commit('setData', shoppingListLines);
        },
        async delete({ state, commit }, params = {}) {
            let paramsMerged = _.merge({}, params, state.filters, state.pagination, { sort: state.sort });

            let response;

            let shoppingListLines;
            response = await apis.ShoppingListLines.deleteShoppingListLine(paramsMerged);
            shoppingListLines = response.body.data;
            commit('setData', shoppingListLines);
        },
    },
    mutations: {
        setData(state, value) {
            state.data = value;
        },
    },
});
